import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Marquee from 'react-fast-marquee';
import { AButton } from '../abutton';
import { kebabCase } from 'lodash';
import {
  convertUrltoCdn,
  randomArrayShuffle,
  useWindowSize,
} from '../../utils/helpers';
import { graphql, useStaticQuery } from 'gatsby';

const AppCarousel = ({ className, integrations: passedIntegrations }) => {
  const data = useStaticQuery(graphql`
    query {
      allStrapiTemplateBlock(
        sort: { name: ASC }
        filter: { logo: { url: { ne: null } }, status: { eq: "Published" } }
      ) {
        edges {
          node {
            id
            name
            icon {
              url
            }
            logo {
              url
            }
            slug
          }
        }
      }
    }
  `);
  const integrations =
    passedIntegrations || data?.allStrapiTemplateBlock?.edges;
  const screenSize = useWindowSize();

  return (
    <div
      className={classNames(
        'relative flex h-full transform-none flex-col sm:h-[unset]',
        className
      )}
    >
      <Marquee
        className="relative flex items-center justify-between sm:!overflow-visible"
        gradient={screenSize.width < 768 ? false : true}
        gradientWidth={200}
        gradientColor="#ffffff"
        speed={28}
        autoFill={true}
      >
        {randomArrayShuffle(integrations).map(({ node }) => {
          return (
            <div
              className="group relative flex h-36 w-[218px] items-center justify-center border-x-[0.5px] border-b-[0.5px] border-t border-black/10 bg-black/3 p-8 hover:bg-white sm:h-[156px]"
              key={node.id}
            >
              <img
                className="h-auto max-h-16 w-auto max-w-full scale-90 object-contain mix-blend-multiply transition-smooth group-hover:mb-10"
                src={
                  convertUrltoCdn(node.logo?.url) ||
                  convertUrltoCdn(node.icon?.url)
                }
                alt={kebabCase(node.name)}
              />
              <div className="absolute bottom-0 opacity-0 transition-smooth group-hover:bottom-6 group-hover:opacity-100">
                <AButton
                  type="tertiary"
                  href={`/integrations/${node.slug}/`}
                  target="_blank"
                  rel="noreferrer"
                  size="sm"
                  hideIcon
                >
                  Explore app
                </AButton>
              </div>
            </div>
          );
        })}
      </Marquee>
      <Marquee
        className="relative flex items-center justify-between sm:!overflow-visible"
        gradient={screenSize.width < 768 ? false : true}
        gradientWidth={200}
        gradientColor="#ffffff"
        speed={21}
        autoFill={true}
      >
        {randomArrayShuffle(integrations).map(({ node }) => {
          return (
            <div
              className="group relative flex h-36 w-[218px] items-center justify-center border-x-[0.5px] border-b border-t-[0.5px] border-black/10 bg-black/3 p-8 hover:bg-white sm:h-[156px]"
              key={node.id}
            >
              <img
                className="h-auto max-h-16 w-auto max-w-full scale-90 object-contain mix-blend-multiply transition-smooth group-hover:mb-10"
                src={
                  convertUrltoCdn(node.logo?.url) ||
                  convertUrltoCdn(node.icon?.url)
                }
                alt={kebabCase(node.name)}
              />
              <div className="absolute bottom-0 opacity-0 transition-smooth group-hover:bottom-6 group-hover:opacity-100">
                <AButton
                  type="tertiary"
                  href={`/integrations/${node.slug}/`}
                  target="_blank"
                  rel="noreferrer"
                  size="sm"
                  hideIcon
                >
                  Explore app
                </AButton>
              </div>
            </div>
          );
        })}
      </Marquee>
    </div>
  );
};

AppCarousel.propTypes = {
  className: PropTypes.string,
  integrations: PropTypes.array,
};

export default AppCarousel;
